export default {
    'Sign up': null,
    'About': null,
    'Newsroom': null,
    'Media Kit': null,
    'Contact': null,
};
